import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { compileAllThemes } from '@redhand/ui';
import '@redhand/ui/kit.css';
import './gallery.css';
import { router } from './router.js';
import { applyTheme, getStoredTheme } from './theme.js';

// Temata kompiluje theme compiler za behu — AA fail-fast: poruseny par
// shodi galerii hned pri startu, ne az v review.
const style = document.createElement('style');
style.textContent = compileAllThemes();
document.head.appendChild(style);

applyTheme(getStoredTheme());

const queryClient = new QueryClient();

const el = document.getElementById('root');
if (!el) throw new Error('Missing #root');
createRoot(el).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
